<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <DeviceDetail slot-scope="{data}" :form-data="data"></DeviceDetail>
  </l-cache>
</template>
<script>
  import DeviceDetail from "./deviceDetail";
  export default {
    name: 'deviceDetailBox',
    components: {DeviceDetail},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('iot/getDeviceList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        if(items.length===0){
          this.$L.alert('error',{message:'未查询到该设备'})
          return {}
        }else{
          return items[0]
        }
      }
    }
  }
</script>
